module.exports = __webpack_public_path__ + "img/karakters-21.ea41050c.jpg";